import React from "react";
import { CalendarDaysIcon } from "@heroicons/react/24/outline";
import { formatDateShort, moneyFormat } from "../utils/utils";

const LoanCard = ({ loan }) => {
    const statusColors = {
        Active: "bg-green-100 text-green-700",
        Pending: "bg-yellow-100 text-yellow-700",
        Completed: "bg-blue-100 text-blue-700",
        Defaulted: "bg-red-100 text-red-700",
    };

    return (
        <div className="bg-white shadow-lg rounded-2xl overflow-hidden border border-gray-100 hover:shadow-xl transition-all duration-300">
            {/* Header */}
            <div className="bg-gradient-to-r from-indigo-500 to-indigo-600 p-4 flex items-center justify-between">
                <h2 className="text-sm font-medium text-white">
                    Loan ID: <span className="font-semibold">{loan.application_number}</span>
                </h2>
                <span
                    className={`px-3 py-1 text-xs font-semibold rounded-full ${statusColors[loan.loan_status.label] || "bg-gray-100 text-gray-700"
                        }`}
                >
                    {loan.loan_status.label}
                </span>
            </div>

            {/* Loan Details */}
            <div className="p-5 space-y-4 text-sm">
                <div className="flex justify-between border-b pb-2">
                    <span className="text-gray-500">Amount Applied</span>
                    <span className="font-bold text-gray-900 text-base">
                        ₦{moneyFormat(loan.loan_amount) || "0.00"}
                    </span>
                </div>
                <div className="flex justify-between border-b pb-2">
                    <span className="text-gray-500">Loan Purpose</span>
                    <span className="font-bold text-gray-900 text-base">
                        {loan.description}
                    </span>
                </div>

                <div className="flex justify-between border-b pb-2">
                    <span className="text-gray-500">Outstanding Balance</span>
                    <span className="font-bold text-red-600 text-base">
                        ₦{loan.outstandingBalance?.toLocaleString() || "0.00"}
                    </span>
                </div>

                <div className="flex justify-between items-center border-b pb-2">
                    <span className="text-gray-500">Date of Application</span>
                    <div className="flex items-center text-gray-900 font-medium">
                        <CalendarDaysIcon className="w-5 h-5 mr-1 text-indigo-500" />
                        {formatDateShort(loan.created_at)}
                    </div>
                </div>

                <div className="flex justify-between items-center">
                    <span className="text-gray-500">Next Repayment Date</span>
                    <div className="flex items-center text-gray-900 font-medium">
                        <CalendarDaysIcon className="w-5 h-5 mr-1 text-indigo-500" />
                        {loan.nextRepaymentDate || "N/A"}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoanCard;
